export default __webpack_public_path__ + "static/media/button_check_answers.8b9699a5.png";